import gql from 'graphql-tag';

export default gql`
  fragment CompleteExpressQueryKiosk on Venue {
    id
    availabilities {
      id
      dayOfWeek
      timeRange {
        id
        start
        end
      }
    }
    image {
      id
      file {
        id
        url
      }
    }
    company {
      id
      defaultOrderStatus
      offers {
        id
        price
        type
        discountType
        discountRate
        overrideItemPrices
        nameLang {
          id
          se
          en
          es
          no
        }
        descriptionLang {
          id
          se
          en
          es
          no
        }
        image {
          id
          file {
            id
            url
          }
        }
        items {
          id
          titleLang {
            id
            se
            en
            es
            no
          }
        }
        stages {
          id
          discountRate
          discountType
          title {
            id
            se
            en
            es
            no
          }
          items {
            id
          }
        }
      }
      categories {
        id
        order
        color
        deleted
        hideInCustomerOrderingFlows
        ukVatRate
        nameLang {
          id
          se
          en
          es
          no
        }
        descriptionLang {
          id
          se
          en
          es
          no
        }
        image {
          id
          file {
            id
            url
          }
        }
        items(filter: { deleted: false }) {
          id
          ageRestricted
          order
          titleLang {
            id
            se
            en
            es
            no
          }
          vatRate
          descriptionLang {
            id
            se
            en
            es
            no
          }

          upsales {
            id
            hideInEPOS
            enableMultiSelect
            name {
              id
              se
              en
              es
              no
            }
            items {
              id
              titleLang {
                id
                se
                en
                es
                no
              }
              defaultPrice
              image {
                id
                file {
                  id
                  url
                }
              }
              categories {
                id
                name
                deleted
              }
            }
          }
          image {
            id
            file {
              id
              url
            }
          }
          defaultPrice
          modificationGroups
          allergyTags
        }
      }
    }
  }
`;
